export const inspectTable_1 = [
  {
    title: "1) 지반상태",
    content: "시설물 주변의 지반 침하 또는 이로 인한 건물의 기움, 균열 등",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "주요 구조부재(보, 기둥, 슬래브, 내력벽)에 균열, 누수 및 누수흔적",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "구조부재의 처짐, 기욺 또는 단면 손실 등의 변형",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "철근 부식, 노출 또는 콘크리트의 박리·박락",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "철골부재의 기욺, 좌굴 등의 변형",
    isChecked: "",
  },
  {
    title: "2) 구조부재",
    content: "철골부재 부식에 의한 단면 결손",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "내부",
    content: "내부 칸막이벽(벽돌, 블록 등)에 균열 및 변형(기욺)",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "내부",
    content: "천장, 벽체 및 바닥 마감재에 파손, 오염, 변형(처짐, 기욺 등), 누수 및 누수흔적",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "옥상, 지붕 방수층의 상태",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "옥상 난간의 과도한 균열, 변형 발생 및 난간 높이(1.2m 이상)",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "지붕 마감재나 외벽재가 바람에 의한 비산의 위험성 여부",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "외벽에 부착되어 있는 기기의 탈락·낙하의 위험성 여부",
    isChecked: "",
  },
  {
    title: "3) 비구조부재",
    subTitle: "외부",
    content: "균열이 있는 유리가 폭설에 의해 파손될 위험성 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "옹벽 파손 및 손상, 균열 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "배면토의 침하, 침수, 배수구 막힘 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "누수, 층 분리 및 박락, 백태 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "철근 노출 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "콘크리트옹벽",
    content: "옹벽상단 토사 및 낙석제거 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "파손 및 손상, 균열, 누수 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "수평이동, 침하, 기울어짐 등 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "변형(배부름 등) 발생 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "배면토의 침하, 침수 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "배수구 설치 및 청소 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "보강토 옹벽 및 석축",
    content: "옹벽 및 석축 상단 토사 및 낙석제거 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "게비온 옹벽",
    content: "채움재 유실 여부",
    isChecked: "",
  },
  {
    title: "4) 부대토목시설",
    subTitle: "게비온 옹벽",
    content: "와이어 메쉬(wire mesh)의 파손 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "주변시설(배수로,측구)의 설치 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "주변 배수시설의 관리 상태",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "배수시설의 배수기능 적합 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "도로융기 발생 여부(도로시설)",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "인접 가로수의 일률적 기울어짐 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "침하의 발생 여부(상부지반)",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "주변 시설 변형 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "인접 지중 매설관의 누수 여부",
    isChecked: "",
  },
  {
    title: "5) 주변시설",
    content: "상·하수시설물 파손 여부",
    isChecked: "",
  },
];

export const inspectTable_2 = [
  {
    title: "1) 바닥부",
    subTitle: "철도",
    content: "배수 및 배수구 상태",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "철도",
    content: "도상부 분리 및 균열 등<br/><span style='font-weight: normal;'>- 분리면 범위 및 균열 진행성</span><br/><span style='font-weight: normal;'>- 신규 균열 발생 여부</span>",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "철도",
    content: "침목의 균열 발생 및 파손",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "도로",
    content: "포장부 파손",
    isChecked: "",
  },
  {
    title: "1) 바닥부",
    subTitle: "도로",
    content: "배수 및 배수구 상태",
    isChecked: "",
  },
  {
    title: "2) 본선 라이닝 점검",
    content: "라이닝 콘크리트 균열 및 누수<br/><span style='font-weight: normal;'>- 파손 및 손상</span><br/><span style='font-weight: normal;'>- 균열 진행성(폭, 길이)</span><br/><span style='font-weight: normal;'>- 누수범위 상태<span></span><br/><span style='font-weight: normal;'>- 재질열화(박리, 박락, 백태, 철근노출 등)</span>",
    isChecked: "",
  },
  {
    title: "2) 본선 라이닝 점검",
    content: "시공이음부 및 타일부 누수 및 들뜸<br/><span style='font-weight: normal;'>- 시공이음부 및 타일부 들뜸 범위 등</span><br/><span style='font-weight: normal;'>- 지하수 용출 및 토사유출 상태</span>",
    isChecked: "",
  },
  {
    title: "2) 본선 라이닝 점검",
    content: "개착구간 라이닝 상태(균열, 누수)",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "터널 상부 지형변화 여부",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "터널 주변 굴착공사 여부",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "갱구부 비탈면 및 옹벽 상태",
    isChecked: "",
  },
  {
    title: "3) 주변지형 및 기타",
    content: "갱문 상부 배수로 상태 및 기타",
    isChecked: "",
  },
];

export const inspectTable_3 = [
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "교면포장(아스콘, 콘크리트) 손상<br/><span style='font-weight: normal;'>- 균열, 소성변형, 요철, 함몰, 체수, 낙수로 인한 결빙</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "배수시설(배수구, 배수관)<br/><span style='font-weight: normal;'>- 파손(Grating, 관), 체수, 막힘</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "난간 및 연석<br/><span style='font-weight: normal;'>- 난간 파손, 부식</span><br/><span style='font-weight: normal;'>- 연석 파손, 박리(염해, 동결융해)</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "신축이음<br/><span style='font-weight: normal;'>- 본체 변형, 씰링 파손, 누수, 이상음</span><br/><span style='font-weight: normal;'>- 후타재 파손, 박리(해빙기 – 동결융해, 염해)</span>",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "포장부 파손",
    isChecked: "",
  },
  {
    title: "1) 상부구조 상면(교면, 배수, 난간 및 연석, 신축이음)",
    content: "배수 및 배수구 상태",
    isChecked: "",
  },
  {
    title: "2) 상부구조 하면(바닥판, 거더, 받침)",
    content: `바닥판(강바닥판, RC)<br/>
<span style='font-weight: normal;'>- 균열, 누수(방수층 손상), 백태</span><br/>
<span style='font-weight: normal;'>- 도장 손상 및 부식, 체수</span><br/>
<span style='font-weight: normal;'>- 강바닥판 변형, RC 철근노출</span>`,
    isChecked: "",
  },
  {
    title: "2) 상부구조 하면(바닥판, 거더, 받침)",
    content: `거더(박스, 플레이트)<br/>
<span style='font-weight: normal;'>- 강박스 내부 우수유입 및 체수 (지점부)</span><br/>
<span style='font-weight: normal;'>- 2차부재 변형, 연결부 상태</span><br/>
<span style='font-weight: normal;'>- 도장 손상 및 부식</span><br/>
<span style='font-weight: normal;'>- 콘크리트 박스 균열, 누수, 백태</span>`,
    isChecked: "",
  },
  {
    title: "2) 상부구조 하면(바닥판, 거더, 받침)",
    content: `받침(강재, 탄성)<br/>
<span style='font-weight: normal;'>- 교좌장치 이동 여유량 확보, 가동불량, 앵커볼트 파손</span><br/>
<span style='font-weight: normal;'>- 거더와 받침연결부 부식, 신축이음 하부 우수유입</span><br/>
<span style='font-weight: normal;'>- 받침모르타르 균열, 파손(동결융해)</span>`,
    isChecked: "",
  },
  {
    title: "3) 하부구조(교대, 교각, 기초)",
    content: `교대<br/>
<span style='font-weight: normal;'>- 흉벽 기울기 이상(측방유동), 토사유실</span><br/>
<span style='font-weight: normal;'>- 균열, 신축이음 누수, 백태</span>`,
    isChecked: "",
  },
  {
    title: "3) 하부구조(교대, 교각, 기초)",
    content: `교각<br/>
<span style='font-weight: normal;'>- 침하(부등침하), 기울기 이상</span><br/>
<span style='font-weight: normal;'>- 균열, 누수, 백태</span>`,
    isChecked: "",
  },
  {
    title: "3) 하부구조(교대, 교각, 기초)",
    content: `기초<br/>
<span style='font-weight: normal;'>- 세굴(직접기초 및 말뚝 노출), 침식</span>`,
    isChecked: "",
  },
];
